import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { Modal } from 'antd';
import { Icon } from '@iconify/react';

import './ConfirmDelete.scss';

const DEFAULT_OPTIONS = {
  title: 'Deseja excluir?',
  message: 'Você realmente deseja remover esse registro?',
  confirmText: 'Excluir',
  cancelText: 'Cancelar',
};

function ConfirmDeleteModal({ options, onConfirm, onCancel }) {
  const { title, message, confirmText, cancelText } = options;
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    try {
      const result = onConfirm();
      await (result && typeof result.then === 'function' ? result : Promise.resolve());
      onCancel();
    } catch (error) {
      setLoading(false);
      throw error;
    }
    setLoading(false);
  };

  return (
    <Modal
      visible
      onCancel={onCancel}
      footer={null}
      closable={false}
      width={476}
      className="confirm-delete-modal">
      <div className="confirm-delete__header">
        <span className="confirm-delete__title">{title}</span>
        <button
          type="button"
          className="confirm-delete__close"
          onClick={onCancel}>
          <Icon icon="fa6-solid:xmark" fontSize={20} />
        </button>
      </div>
      <div className="confirm-delete__body">
        <p className="confirm-delete__text">{message}</p>
        <div className="confirm-delete__actions">
          <button
            type="button"
            className="confirm-delete__btn confirm-delete__btn--outline"
            onClick={onCancel}>
            {cancelText}
          </button>
          <button
            type="button"
            className="confirm-delete__btn confirm-delete__btn--filled"
            onClick={handleConfirm}
            disabled={loading}>
            {confirmText}
          </button>
        </div>
      </div>
    </Modal>
  );
}

function ConfirmDelete(callBack, messageOrOptions = undefined) {
  const options =
    typeof messageOrOptions === 'string'
      ? { ...DEFAULT_OPTIONS, message: messageOrOptions }
      : { ...DEFAULT_OPTIONS, ...messageOrOptions };

  const container = document.createElement('div');
  document.body.appendChild(container);

  const close = () => {
    ReactDOM.unmountComponentAtNode(container);
    document.body.removeChild(container);
  };

  ReactDOM.render(
    <ConfirmDeleteModal
      options={options}
      onConfirm={callBack}
      onCancel={close}
    />,
    container
  );
}

export default ConfirmDelete;
